import { EpimsGenderDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as GenderAction from './gender.actions';

export const GENDER_FEATURE_KEY = 'gender';

export interface GenderState extends EntityState<EpimsGenderDto> {
  selectedGenderId?: string | number; // which Gender record has been selected
  loaded: boolean; // has the Gender list been loaded
  error?: string | null; // last none error (if any)
}

export interface GenderPartialState {
  readonly [GENDER_FEATURE_KEY]: GenderState;
}

export const genderAdapter: EntityAdapter<EpimsGenderDto> = createEntityAdapter<
  EpimsGenderDto
>({
  selectId: (gender) => gender.id,
  sortComparer: false,
});

export const initialState: GenderState = genderAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedGenderId: null,
});

const genderReducer = createReducer(
  initialState,
  on(GenderAction.loadGender, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(GenderAction.loadGenderSuccess, (state, { gender }) =>
    genderAdapter.addAll(gender, { ...state, loaded: false })
  ),
  on(GenderAction.loadGenderFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(GenderAction.addGender, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(GenderAction.addGenderSuccess, (state, { newGender }) =>
    genderAdapter.addMany(newGender, { ...state, loaded: false })
  ),
  on(GenderAction.addGenderFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(GenderAction.updateGender, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(GenderAction.updateGenderSuccess, (state, { updateGender }) =>
    genderAdapter.upsertMany(updateGender, { ...state, loaded: false })
  ),
  on(GenderAction.updateGenderFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(GenderAction.removeGender, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(GenderAction.removeGenderSuccess, (state, { ids }) =>
    genderAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(GenderAction.removeGenderFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: GenderState | undefined, action: Action) {
  return genderReducer(state, action);
}
